export default __webpack_public_path__ + "static/media/footer-logo.fed14ffc.svg";